import gql from 'graphql-tag';

export const NAME =
  'compositions_CaseDetailOverviewPanel_updateCaseHeadsUpNoteMutation';

export default gql`
  mutation ${NAME} ($caseId: ID!, $note: String) {
    updateCase(input: { id: $caseId, patch: { quickNote: $note } }) {
      case { id quickNote }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseHeadsUpNote/updateCaseHeadsUpNoteMutation.js